  export const initialForm={
    sapPlantId:'',
    sapBusinessArea:'',
    sapDescription:'',
    businessPlaceCode:'',
    defermentBusinessArea:'',
    gstInNumber:''
  }

  export const getReqObj= (form)=>{
    return {
    sapPlantId:form?.sapPlantId,
    sapBusinessArea:form?.sapBusinessArea,
    sapDescription: form?.sapDescription,
    businessPlaceCode: form?.businessPlaceCode,
    defermentBusinessArea:form?.defermentBusinessArea,
    gstInNumber:form?.gstInNumber,
    businessAreaId: form?.buId
}
  }

  export const statusMapping={
    SUCCESS: 'Success',
    NOTMAPPED: "Not Mapped",
    FAILED: "Failed"
  }
  const COMMON_STYLE={
    fontSize: '14px',
      fontWeight: 600,
      lineHeight: '20px',
  }

 export  const statusMappingStyle={
    SUCCESS:{
      ...COMMON_STYLE,
      color: '#05945B'
    },
    FAILED:{
       ...COMMON_STYLE,
       color:'#D29822'
    },
    NOTMAPPED:{
      ...COMMON_STYLE,
      color: '#757575'
    }
  }

export const getLatestUpdateInfo = (entry1, entry2) => {
  const isValidDate = (dateStr) => dateStr && !isNaN(Date.parse(dateStr));

  const date1 = isValidDate(entry1?.updatedOn) ? new Date(entry1.updatedOn) : null;
  const date2 = isValidDate(entry2?.updatedOn) ? new Date(entry2.updatedOn) : null;

  if (date1 && date2) {
    return date1 > date2 ? entry1 : entry2;
  }

  // Return whichever entry has a valid date, or null if neither
  return date1 ? entry1 : date2 ? entry2 : null;
};
